<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <selectedInvoicesSum :selected-invoices="selectedInvoicesToSend" />
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
        <b-button aria-controls="invoice_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.invoice_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="invoice_search_collapse" class="mt-2">
          <InvoiceFiltering
            :filters="$store.state.filters.invoiceAcceptedFilter"
            :filterReference="$store.state.filters.invoiceAcceptedReference"
            :currentPageProp="$store.state.filters.invoiceAcceptedCurrentPage"
            :periodDateProp="$store.state.filters.invoiceAcceptedPeriodDate"
            :dateTypeProp="$store.state.filters.invoiceAcceptedDateType"
            @currentPageChange="$store.state.filters.invoiceAcceptedCurrentPage = $event"
            @periodDateChange="$store.state.filters.invoiceAcceptedPeriodDate = $event"
            @dateTypeChange="$store.state.filters.invoiceAcceptedDateType = $event"
            @getPage="getPage($event)" ref="invoiceAcceptedFiltering"></InvoiceFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <b-row>
        <b-col>
          <div v-if="isLoading">
            <Loader></Loader>
          </div>
          <div v-else-if="!isLoading && items.length < 1">
            {{ $t('views.exsbinvoices.list.noInvoices') }}
          </div>
          <div v-else>
            <table class="table table-sm table-responsive-md table-striped table-hover">
              <thead>
              <tr>
                <th>
                  <b-form-checkbox @change="toggleSelectCurrentPage()" :checked="checkboxSelectAllStatus"  :indeterminate="checkboxSelectIndeterminateStatus"></b-form-checkbox>
                </th>
                <th>{{ $t('views.exsbinvoices.form.number') }}</th>
                <th>{{ $t('views.exsbinvoices.list.type') }}</th>
                <th>{{ $t('views.exsbinvoices.list.seller') }}</th>
                <th>{{ $t('views.exsbinvoices.list.buyer') }}</th>
                <th>{{ $t('views.exsbinvoices.list.agreementTags') }}</th>
                <th>{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}</th>
                <th>{{ $t('views.exsbinvoices.list.issueDate') }}</th>
                <th>{{ $t('views.exsbinvoices.list.sellDate') }}</th>
                <th>{{ $t('views.exsbinvoices.list.beforeCorrection') }}</th>
                <th>{{ $t('views.exsbinvoices.list.correctionDifference') }}</th>
                <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
                <th>{{ $t('views.exsbinvoices.list.totalValueNetto') }}</th>
                <th>{{ $t('views.exsbinvoices.list.totalValueBrutto') }}</th>
                <th>{{ $t('views.exsbinvoices.list.toPay') }}</th>
                <th colspan="2" />
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items" :key="item['@id']">
                <td>
                  <div style="margin: 0 auto; display: table;">
                    <b-form-checkbox v-model="selectedInvoicesToSend" :value="item"></b-form-checkbox>
                  </div>
                </td>
                <td>
                    <router-link
                      :to="{name: 'EXSBInvoiceShow', params: { id: item['@id'] }}"
                      v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true">{{item.number || $t('views.agreements.list.noNumber')}}
                    </router-link>
                  <p style="font-size: 8px; white-space: nowrap" v-if="item.ksefElementReferenceNumber">
                    {{$t('views.exsbinvoices.list.ksefReferenceNumber')}}: {{item.ksefElementReferenceNumber}}
                  </p>
                  <b-badge v-if="item.sent === 1" style="cursor:pointer;" variant="success">
                    {{ $t('views.exsbinvoices.list.sent') }}
                  </b-badge>
<!--                  <v-tooltip top v-if="item.ksefProcessingDescription">-->
<!--                    <template v-slot:activator="{ on, attrs }">-->
<!--                      <v-chip v-if="item.ksefProcessingDescription" x-small :color="getKsefStatusColor(item)" v-bind="attrs" v-on="on">-->
<!--                        <div>-->
<!--                          <v-icon x-small left>{{getKsefStatusIcon(item)}}</v-icon>-->
<!--                          {{$t('views.exsb.vat_invoices.ksefProcessingDescriptionShort')}}-->
<!--                        </div>-->
<!--                      </v-chip>-->
<!--                    </template>-->
<!--                    {{$t('views.exsb.vat_invoices.ksefProcessingDescription')}}: {{item.ksefProcessingDescription}}-->
<!--                  </v-tooltip>-->
                  <b-badge :variant="getKsefStatusVariant(item)" v-if="item.ksefProcessingDescription" v-b-tooltip.hover :title="$t('views.exsbinvoices.list.ksefProcessingDescription') + ': ' + item.ksefProcessingDescription">
                    <i :class="['fa', getKsefStatusIcon(item), 'fa-lg']"></i> {{ $t('views.exsbinvoices.list.ksefProcessingDescriptionShort') }}
                  </b-badge>
                  <span v-if="item.invoiceCorrectionOf">
                    <br>
                    <small>
                      <router-link :to="{name: 'EXSBInvoiceShow', params: { id: item.invoiceCorrectionOf['@id'] }}">
                        <span class="text-danger">
                          {{ $t('views.exsbinvoices.form.corOf') }} {{ item.invoiceCorrectionOf.number }}
                        </span>
                      </router-link>
                    </small>
                  </span>
                  <span v-if="item.correctionId">
                      <br>
                      <small>
                        <router-link :to="{name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + item.correctionId }}">
                          <span class="text-danger">
                            {{ $t('views.exsbinvoices.form.corection') }} {{ item.correctionNumber }}
                          </span>
                        </router-link>
                      </small>
                    </span>
                </td>
                <td>
                  <p class="m-0" v-if="item.correctionOf && item.invoiceType && item.invoiceType.id === 1">{{ $t('views.exsb.vat_invoices.form.corOfTypeWithVat') }}</p>
                  <p class="m-0" v-else-if="item.correctionOf && item.invoiceType && item.invoiceType.id === 2">{{ $t('views.exsb.vat_invoices.form.corOfTypeNoVat') }}</p>
                  <p class="m-0" v-else>{{ item.invoiceType.name }}</p>
                  <b-badge v-if="item.cancellation === 1" style="cursor:pointer;" variant="danger">
                    {{ $t('views.exsb.vat_invoices.show.invoiceCancellation') }} <br>
                    {{ $t('views.exsb.vat_invoices.show.invoiceCancellationBy') }} {{item.cancellationByUser}} <br>
                    {{ $t('views.exsb.vat_invoices.show.invoiceCancellationDate') }} {{$moment(item.cancellationDate).format('YYYY-MM-DD')}}
                  </b-badge>
                </td>
                <td>
                  {{ item.sellerName }}
                </td>
                <td>
                  <router-link :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                    <div>{{ item.buyerName }}</div>
                  </router-link>
                  <router-link v-if="item.idAgreement" :to="{name: 'EXABAgreementShow', params: {id: item.idAgreement['@id']}}"><b-badge>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.moveToAgreement') }}</b-badge></router-link>
                </td>
                <td>
                  <template v-if="item.idAgreement">
                    <p class="m-0 p-0" v-for="tag in item.idAgreement.agreementTags" :key="tag['@id']">
                      <b-badge pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
                    </p>
                  </template>
                </td>
                <td>
                  <i v-if="item.comments" class="fa fa-eye fa-lg ml-4" :id="'invoice_info' + item['@id']"></i>
                  <b-popover custom-class="box-shadow shadow-sm bg-white rounded"
                             triggers="hover" placement="top" variant="secondary" :target="'invoice_info' + item['@id']">
                    <span>{{item.comments}}</span>
                  </b-popover>
                </td>
                <td>
                  {{ $moment(item['issueDate']).format('YYYY-MM-DD') }}
                </td>
                <td>
                  {{ $moment(item['sellDate']).format('YYYY-MM-DD') }}
                </td>
                <td>
                  {{ item['beforeCorrection'] }}
                </td>
                <td>
                  {{ item['correctionDifference'] }}
                </td>
                <td>
                  {{ $moment(item['paymentDeadline']).format('YYYY-MM-DD') }}
                </td>
                <td>
                  {{ item['totalValueNetto'].toFixed(2) }}
                </td>
                <td>
                  {{ item['totalValueBrutto'].toFixed(2) }}
                </td>
                <td>
                  <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '1'"><span class="text-danger">{{ $t('global.noPayment') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                  <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '2'"><span class="text-success">{{ $t('global.paymentFull') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                  <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '3'"><span class="text-warning">{{ $t('global.paymentPartial') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                  <b-badge v-if="item.idReceipt" variant="danger">
                    {{ $t('global.documentHasReceipt') }}
                  </b-badge>
                </td>
                <td>
                  <b-dropdown variant="link" size="sm" right text="Right align">
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item @click="editSingle(item['@id'])"><i class="fa fa-edit"></i> {{$t('buttons.edit')}}</b-dropdown-item>
                    <b-dropdown-item v-if="item.cancellation === 0 && item.type && item.type.id !== 3 && item.type.id !== 11"
                                     @click="correction(item.id)"><i class="fa fa-edit"></i> {{$t('buttons.correction')}}</b-dropdown-item>
                    <b-dropdown-item v-if="item.cancellation === 0 && item.status.id !== 2"
                                     @click="showAddPaymentToInvoiceModal(item)" ><i class="fas fa-usd-circle"></i> {{$t('buttons.doPayment')}}</b-dropdown-item>
                    <b-dropdown-item v-if="item.cancellation === 0 && item.type && item.type.id !== 3 && item.type.id !== 11 &&
                                     item.status.id !== 2"
                                     @click="cancellationInvoice(item)"><i class="fa fa-trash"></i> {{$t('buttons.cancellationInvoice')}}</b-dropdown-item>
                    <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                    <b-dropdown-item v-if="isKsefEnabledForInvoice(item) && ((item.ksefProcessingInProgress === 0 && !item.ksefProcessingDescription) || item.ksefProcessingInProgress === -1)" @click="showModalToSendInvoiceToKSeF(item)">
                      <i class="fa fa-file-code"></i> {{ $t('buttons.sendInvoiceToKsef') }}</b-dropdown-item>
                    <b-dropdown-item v-if="item.ksefProcessingInProgress === 1 || item.ksefProcessingInProgress === 2" @click="checkInvoiceStatusOnKSeF(item['@id'])">
                      <i class="fa fa-spinner"></i> {{ $t('buttons.checkInvoiceStatusOnKSeF') }}</b-dropdown-item>
                    <b-dropdown-item v-if="item.ksefLocalUpoXml" @click="downloadUpoXml(item)">
                      <i class="fa fa-file-code"></i> {{ $t('buttons.downloadUpoXml') }}</b-dropdown-item>
                    <b-dropdown-item v-else-if="item.ksefProcessingInProgress === 0 && item.ksefElementReferenceNumber" @click="checkAndDownloadUpoXml(item)">
                      <i class="fa fa-file-code"></i> {{ $t('buttons.checkAndDownloadUpoXml') }}</b-dropdown-item>
                  </b-dropdown>

                </td>
              </tr>
              <tr v-if="items.length > 0 && totalSums && totalSums.length > 0">
                <td colspan="11">{{ $t('views.exsbinvoices.form.totalSums') }}</td>
                <td>{{ totalSums[0].sumTotalValueNetto }}</td>
                <td>{{ totalSums[0].sumTotalValueBrutto }}</td>
                <td colspan="2">{{ totalSums[0].sumToPay }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="view">
            <pagination
              :view="view"
              :totalItems="totalItems"
              @getPage="getPage($event)"
              @getPageNumber="setCurrentPage($event.page)"
            ></pagination>
          </div>
          <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedInvoicesToSend.length }}</b></p>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
          <b-dropdown size="sm" variant="warning" dropright text="Drop-Right" :disabled="selectedInvoicesToSend.length === 0">
            <template #button-content>
              {{ $t('buttons.collectionOperations') }}
            </template>
            <b-dropdown-item @click="showModalToSendSelectedInvoices"><i class="fa fa-envelope mr-2"></i>{{$t('views.exsbinvoices.form.sendSelectedInvoices')}}</b-dropdown-item>
            <b-dropdown-item v-if="$store.getters['configuration/ksefEnabled']" @click="showModalToSendSelectedInvoicesToKSeF"><i class="fa fa-envelope mr-2"></i>{{$t('views.exsbinvoices.form.sendSelectedInvoicesToKSeF')}}</b-dropdown-item>
            <b-dropdown-item v-if="$store.getters['configuration/ksefEnabled']" @click="showModalToSendSelectedInvoicesToKSeFOnlyMessage"><i class="fa fa-envelope mr-2"></i>{{$t('views.exsbinvoices.form.sendSelectedInvoicesToKSeFOnlyMessage')}}</b-dropdown-item>
            <b-dropdown-item @click="pdfSelectedInvoices"><i class="fa fa-file-pdf mr-2"></i>{{$t('views.exsbinvoices.form.pdfSelectedInvoices')}}</b-dropdown-item>
            <b-dropdown-item @click="zipSelectedInvoices"><i class="fa fa-file-pdf mr-2"></i>{{$t('views.exsbinvoices.form.zipSelectedInvoices')}}</b-dropdown-item>
            <b-dropdown-item @click="fa3SelectedInvoices"><i class="fa fa-file-pdf mr-2"></i>{{$t('views.exsbinvoices.form.fa3SelectedInvoices')}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-modal size="lg" ref="modalToSendInvoice" hide-footer>
        <div slot="modal-header">
          <h6 class="modal-title m-0 float-left">
            {{$t('views.exsbinvoices.modal.modalHeader')}}
          </h6>
          <button type="button" aria-label="Close" class="close" @click="hideModalToSendSelectedInvoices()">
            ×
          </button>
        </div>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>{{$t('views.exsbinvoices.form.sentDate')}}:</label>
              <VueCtkDateTimePicker no-header
                                    :label="$t('views.exsbinvoices.form.sentDate')"
                                    v-model="sentDate"
                                    format="YYYY-MM-DD HH:mm"
                                    :onlyDate="false"
                                    :right="true"
                                    formatted="YYYY-MM-DD HH:mm"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label for="custom_email_content">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
              <input
                id="issuePlace"
                v-model="invoiceSettings.invoiceMailTitle"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
              <trumbowyg ref="editor" v-model="invoiceSettings.customEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
              </trumbowyg>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <button @click="sendSelectedInvoices" class="btn btn-primary">{{ $t('views.exsbinvoices.form.sendSelectedInvoices') }}</button>
            <b-btn @click="hideModalToSendSelectedInvoices" variant="danger">{{ $t('buttons.close') }}</b-btn>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal size="lg" ref="modalToSendInvoicesToKSeF" hide-footer>
        <div slot="modal-header">
          <h6 class="modal-title m-0 float-left">
            {{$t('views.exsbinvoices.modal.sendToKSeF')}}
          </h6>
          <button type="button" aria-label="Close" class="close" @click="hideModalToSendSelectedInvoicesToKSeF()">
            ×
          </button>
        </div>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
              <trumbowyg ref="editor" v-model="invoiceSettings.ksefEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
              </trumbowyg>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <button @click="sendSelectedInvoicesToKSeF" class="btn btn-primary">{{ $t('views.exsbinvoices.form.sendSelectedInvoicesToKSeF') }}</button>
            <b-btn @click="hideModalToSendSelectedInvoicesToKSeF" variant="danger">{{ $t('buttons.close') }}</b-btn>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal size="lg" ref="modalToSendInvoiceToKSeF" hide-footer>
        <div slot="modal-header">
          <h6 class="modal-title m-0 float-left">
            {{$t('buttons.sendInvoiceToKsef')}}
          </h6>
          <button type="button" aria-label="Close" class="close" @click="hideModalToSendInvoiceToKSeF()">
            ×
          </button>
        </div>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
              <trumbowyg ref="editor" v-model="invoiceSettings.ksefEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
              </trumbowyg>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <button @click="sendInvoiceToKsef" class="btn btn-primary">{{ $t('buttons.sendInvoiceToKsef') }}</button>
            <b-btn @click="hideModalToSendInvoiceToKSeF" variant="danger">{{ $t('buttons.close') }}</b-btn>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal size="lg" ref="modalToSendInvoicesToKSeFOnlyMessage" hide-footer>
        <div slot="modal-header">
          <h6 class="modal-title m-0 float-left">
            {{$t('views.exsbinvoices.form.sendSelectedInvoicesToKSeFOnlyMessage')}}
          </h6>
          <button type="button" aria-label="Close" class="close" @click="hideModalToSendSelectedInvoicesToKSeFOnlyMessage()">
            ×
          </button>
        </div>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
              <trumbowyg ref="editor" v-model="invoiceSettings.ksefEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
              </trumbowyg>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <button @click="sendSelectedInvoicesToKSeFOnlyMessage" class="btn btn-primary">{{ $t('views.exsbinvoices.form.sendSelectedInvoicesToKSeFOnlyMessage') }}</button>
            <b-btn @click="hideModalToSendSelectedInvoicesToKSeFOnlyMessage" variant="danger">{{ $t('buttons.close') }}</b-btn>
          </b-col>
        </b-row>
      </b-modal>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import InvoiceFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoiceFiltering'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import addParamsToQuery from '@/utils/addParamsToQuery'
import SelectedInvoicesSum from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/SelectedInvoicesSum'

export default {
  components: {
    SelectedInvoicesSum,
    Loader,
    Pagination,
    BaseTableWrapper,
    InvoiceFiltering,
    Trumbowyg,
    VueCtkDateTimePicker
  },

  props: {
    firmIRI: {
      type: String
    },
    accepted: {
      default: () => 1
    }
  },
  data () {
    return {
      selectedInvoicesToSend: [],
      invoiceToSendToKSeF: null,
      sentDate: '',
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      },
      invoiceSettings: {
        issuePlace: '',
        comments: '',
        customEmail: '',
        invoiceMailTitle: '',
        ksefEmail: ''
      },
      searchParams: this.$store.state.filters.invoiceAcceptedFilter
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'exsbinvoice/del/deleted',
      error: 'exsbinvoice/list/error',
      items: 'exsbinvoice/list/items',
      isLoading: 'exsbinvoice/list/isLoading',
      view: 'exsbinvoice/list/view',
      totalItems: 'exsbinvoice/list/totalItems',
      totalSums: 'exsbinvoice/list/totalSums'
    }),
    filterStatus () {
      return (
        (JSON.stringify(this.$store.state.filters.invoiceAcceptedFilter) !== JSON.stringify(this.$store.state.filters.invoiceAcceptedReference)) ||
        this.$store.state.filters.invoiceAcceptedPeriodDate !== '' ||
        this.$store.state.filters.invoiceAcceptedDateType !== 1
      )
    },
    checkboxSelectAllStatus () {
      // Sprawdzenie czy wszystkie elementy z items znajdują się w selectedInvoicesToSend. Kolejność nie ma znaczenia
      return this.items.every(item => this.selectedInvoicesToSend.includes(item))
    },
    checkboxSelectIndeterminateStatus () {
      if (this.checkboxSelectAllStatus) {
        return false
      }
      return this.items.some(item => this.selectedInvoicesToSend.includes(item))
    }
  },
  beforeCreate () {
    if (Object.keys(this.$store.state.filters.invoiceAcceptedReference).length === 0) {
      this.$store.state.filters.invoiceAcceptedReference = {
        number: '',
        buyerFilter: '',
        invoicePositionsFilter: '',
        invoiceType: '',
        invoiceStatus: '',
        correctionFilter: null,
        order: 0,
        paymentWay: '',
        'paymentDeadline[after]': '',
        'paymentDeadline[before]': '',
        'issueDate[after]': '',
        'issueDate[before]': '',
        'sellDate[after]': '',
        'sellDate[before]': '',
        issuePlace: '',
        accepted: 1,
        sent: '',
        comments: '',
        'idUserData.userDataTags.idTag': [],
        'idAgreement.agreementTags.tag': [],
        ksefStatusFilter: 0,
        hasDiscountFilter: ''
      }
    }
    if (Object.keys(this.$store.state.filters.invoiceAcceptedFilter).length === 0) {
      this.$store.state.filters.invoiceAcceptedFilter = JSON.parse(JSON.stringify(this.$store.state.filters.invoiceAcceptedReference))
    }
    checkPagePermission('finances', 'EXSBInvoiceList')
  },
  watch: {
    accepted () {
      this.getList()
    }
  },
  created () {
    this.getList()
    this.getInvoiceSettings()
    this.channelBusinessInvoice = this.$store.state.Pusher.subscribe('e_x_s_b_invoices')
    this.channelBusinessInvoice.bind('e_x_s_b_invoices', data => {
      this.getList()
    })
  },
  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_invoices')
  },

  methods: {
    clearFilters () {
      if (this.$refs.invoiceAcceptedFiltering) {
        this.$refs.invoiceAcceptedFiltering.clearFilters()
      }
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getList()
      })
    },
    async sendInvoiceToKsef () {
      let params = { ksefPreparedEmailContent: this.invoiceSettings.ksefEmail }
      await new ApiService(this.invoiceToSendToKSeF + '/sendtoksef').put(params)
      this.hideModalToSendInvoiceToKSeF()
      this.getList()
    },
    async checkInvoiceStatusOnKSeF (itemId) {
      await new ApiService(itemId + '/statusksef').put()
      this.getList()
    },
    downloadUpoXml (item) {
      let xmlContents = item.ksefLocalUpoXml
      let fileName = item.number + '.xml'
      // Stwórz blob
      let myBlob = new Blob([xmlContents], { type: 'text/xml' })

      let url = window.URL.createObjectURL(myBlob)
      let a = document.createElement('a')
      a.href = url
      a.setAttribute('download', fileName)
      document.body.appendChild(a)
      a.click()
      setTimeout(function () {
        window.URL.revokeObjectURL(url)
      }, 0)
    },
    async checkAndDownloadUpoXml (item) {
      await new ApiService(item['@id'] + '/upoksef').downloadFile(item.number + '.xml')
    },
    pdfSelectedInvoices () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections
      }
      new ApiService('e_x_s_b_invoicespdfgenerate', params).downloadFile('FakturyZbiorcze.pdf' + ' ' + this.$moment().format('YYYY-MM-DD'))
    },
    zipSelectedInvoices () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections
      }
      new ApiService('e_x_s_b_invoiceszipgenerate', params).downloadFile(this.$moment().format('YYYY-MM-DD') + '_FakturyZbiorcze.zip')
    },
    fa3SelectedInvoices () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections
      }
      new ApiService('e_x_s_b_invoicesfa3generate', params).downloadFile(this.$moment().format('YYYY-MM-DD') + '_FakturyZbiorczeFA3.zip')
    },
    showModalToSendSelectedInvoices () {
      this.$refs['modalToSendInvoice'].show()
    },
    hideModalToSendSelectedInvoices () {
      this.$refs['modalToSendInvoice'].hide()
    },
    showModalToSendInvoiceToKSeF (item) {
      this.invoiceToSendToKSeF = item['@id']
      this.$refs['modalToSendInvoiceToKSeF'].show()
    },
    hideModalToSendInvoiceToKSeF () {
      this.invoiceToSendToKSeF = null
      this.$refs['modalToSendInvoiceToKSeF'].hide()
    },
    showModalToSendSelectedInvoicesToKSeF () {
      this.$refs['modalToSendInvoicesToKSeF'].show()
    },
    hideModalToSendSelectedInvoicesToKSeF () {
      this.$refs['modalToSendInvoicesToKSeF'].hide()
    },
    showModalToSendSelectedInvoicesToKSeFOnlyMessage () {
      this.$refs['modalToSendInvoicesToKSeFOnlyMessage'].show()
    },
    hideModalToSendSelectedInvoicesToKSeFOnlyMessage () {
      this.$refs['modalToSendInvoicesToKSeFOnlyMessage'].hide()
    },
    async sendSelectedInvoices () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections,
        sentDate: this.sentDate,
        messageTitle: this.invoiceSettings.invoiceMailTitle,
        messageContent: this.invoiceSettings.customEmail
      }
      await new ApiService('e_x_s_b_invoices/invoicessend').post(params)
      this.getList()
      this.getInvoiceSettings()
      this.$refs['modalToSendInvoice'].hide()
    },
    async sendSelectedInvoicesToKSeF () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections,
        ksefPreparedEmailContent: this.invoiceSettings.ksefEmail
      }
      await new ApiService('e_x_s_b_invoices/invoicessendtoksef').post(params)
      this.getList()
      this.getInvoiceSettings()
      this.$refs['modalToSendInvoicesToKSeF'].hide()
    },
    async sendSelectedInvoicesToKSeFOnlyMessage () {
      let selections = []
      for (let i in this.selectedInvoicesToSend) {
        selections.push(this.getIdLink(this.selectedInvoicesToSend[i]['@id']))
      }
      let params = {
        selections: selections,
        ksefPreparedEmailContent: this.invoiceSettings.ksefEmail
      }
      await new ApiService('e_x_s_b_invoices/invoicessendtoksefonlymessage').post(params)
      this.getList()
      this.getInvoiceSettings()
      this.$refs['modalToSendInvoicesToKSeFOnlyMessage'].hide()
    },
    selectAll () {
      let selectAll = []
      for (let i in this.items) {
        selectAll.push(this.items[i])
      }
      this.selectedInvoicesToSend = selectAll
    },
    unSelectAll () {
      this.selectedInvoicesToSend = []
    },
    toggleSelectCurrentPage () {
      if (this.checkboxSelectAllStatus) {
        // Usuń wszystkie checkboxy z bieżącej strony
        this.selectedInvoicesToSend = this.selectedInvoicesToSend.filter(item => !this.items.includes(item))
      } else {
        // Dodaj brakujące elementy z bieżącej strony
        this.selectedInvoicesToSend = [...this.selectedInvoicesToSend, ...this.items.filter(item => !this.selectedInvoicesToSend.includes(item))]
      }
    },
    editSingle (id) {
      this.$router.push({ name: 'EXSBInvoiceUpdate', params: { id: id } })
    },
    isKsefEnabledForInvoice (item) {
      return this.$store.getters['configuration/ksefEnabled']
    },
    getKsefStatusVariant (item) {
      if (item.ksefProcessingInProgress === -1) {
        return 'error'
      }
      if (item.ksefProcessingInProgress === 1 || item.ksefProcessingInProgress === 2 || !item.ksefProcessingDescription.startsWith('200')) {
        return 'warning'
      }
      return 'success'
    },
    getKsefStatusIcon (item) {
      if (item.ksefProcessingInProgress === -1) {
        return 'fa-exclamation-circle'
      }
      if (item.ksefProcessingInProgress === 1 || item.ksefProcessingInProgress === 2 || !item.ksefProcessingDescription.startsWith('200')) {
        return 'fa-spinner'
      }
      return 'fa-check-circle'
    },
    getList () {
      let params = Object.assign({ '_page': this.$store.state.filters.invoiceAcceptedCurrentPage }, this.searchParams)
      if (typeof params.order !== 'undefined') {
        if (params.order === 1) {
          params['order[createdAt]'] = 'desc'
        } else if (params.order === 0) {
          params['order[issueDate]'] = 'desc'
          params['order[numberValue]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
        } else if (params.order === 2) {
          params['order[issueDate]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
          params['order[numberValue]'] = 'desc'
        } else if (params.order === 3) {
          params['order[sellDate]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
          params['order[numberValue]'] = 'desc'
        }
      }
      params.order = undefined
      let url = addParamsToQuery('e_x_s_b_invoices', params)
      this.getPage(url)
    },
    setCurrentPage (page) {
      this.$store.state.filters.invoiceAcceptedCurrentPage = page
    },
    async getInvoiceSettings () {
      let owner = await new ApiService('owners/1').getResults()
      if (!owner.invoiceSettings || owner.invoiceSettings.length === 0) {
        this.invoiceSettings = {
          issuePlace: '',
          comments: '',
          customEmail: '',
          invoiceMailTitle: '',
          ksefEmail: ''
        }
      } else {
        this.invoiceSettings = owner.invoiceSettings
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapActions({
      getPage: 'exsbinvoice/list/getItems'
    })
  }
}
</script>
